import { useMemo } from 'react'
import { ifcRootGuid } from '@constants'
import { useProjectFiles } from '.'

/** A converted IFC model (the GLB the scene loads), as opposed to the IFC and its other derivatives. */
export const isGlbFile = (file: FileItem): boolean =>
  file.mimetype === 'application/glb' ||
  file.mimetype === 'model/gltf-binary' ||
  file.mimetype === 'application/octet-stream'

const useIfcFiles = () => {
  const { data: filesData } = useProjectFiles(ifcRootGuid)

  const glbFiles = useMemo(() => {
    if (!filesData?.files) return []
    return filesData.files.filter(isGlbFile)
  }, [filesData])

  return glbFiles
}

export default useIfcFiles
